import { useState, useEffect } from 'react';
import {useBaseApi} from "../useBaseApi";

export function usePositions() {
    const [positions, setPositions] = useState([]);
    const {get} = useBaseApi();

    useEffect( () => {
        load();
    }, []);

    const load = async () => {
        let response = await get("/position", false);
        setPositions(response.data);
    }

    return [positions];

}